import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ALL_COLUMNS } from '../../utils/jobconstant';
import { formatValue } from '../../utils/excelUtils';

const DataTable = ({
  currentItems,
  selectedColumns,
  indexOfFirstItem,
}) => {
  const navigate = useNavigate();

  const getRowClassName = (item) => {
    // 🔥 Highest priority → unseen jobs
    if (!item.isSeen) return "unseen-row";

    const status = item.jobReqStatus || item.status;
    switch (status?.toLowerCase()) {
      case 'closed':
        return 'closed-row';
      case 'on hold':
        return 'onhold-row';
      case 'active':
        return 'active-row';
      case 'inactive':
        return 'inactive-row';
      default:
        return '';
    }
  };


  const getUniqueId = (item, index) => {
    return item.id ||
      item.jobReqId ||
      `${item.companyName}-${item.jobTitle}-${index}` ||
      `row-${indexOfFirstItem + index}`;
  };

  // DataTable.jsx - replace handleJobReqIdClick
  const handleJobReqIdClick = async (e, item) => {
    e.stopPropagation();

    const jobReqId = item.jobReqId || item.id;

    if (jobReqId) {
      try {
        const token = localStorage.getItem("token");
        await fetch(`${process.env.REACT_APP_API_URL}/job/view/${jobReqId}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` })
          }
        });
      } catch (err) {
        console.error("Error marking job as viewed:", err);
      }

      // ✅ Use guardedNavigate if available (user is inside EditJobRequirement)
      // otherwise plain navigate (user is on dashboard — no guard needed)
      if (window.__guardedNavigate) {
        window.__guardedNavigate(`/edit-job/${jobReqId}`);
      } else {
        navigate(`/edit-job/${jobReqId}`);
      }
    }
  };

  const visibleColumns = ALL_COLUMNS.filter(column => selectedColumns.includes(column.key));

  return (
    <div className="table-container">
      <table className="records-table">
        <thead>
          <tr>
            {visibleColumns.map(column => (
              <th key={column.key} className={`column-${column.key}`}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentItems.length === 0 ? (
            <tr>
              <td colSpan={visibleColumns.length} style={{ textAlign: 'center', padding: '20px' }}>
                No job requirements found
              </td>
            </tr>
          ) : (
            currentItems.map((item, rowIndex) => {
              const rowClass = getRowClassName(item);
              const rowId = getUniqueId(item, rowIndex);

              return (
                <tr key={rowId} className={rowClass}>
                  {visibleColumns.map(column => {
                    const value = item[column.key];
                    const formattedValue = formatValue(value);

                    let cellContent = formattedValue;

                    if (column.key === 'jobReqId') {
                      // Make only jobReqId clickable
                      cellContent = (
                        <span
                          className="clickable-job-id"
                          onClick={(e) => handleJobReqIdClick(e, item)}
                          style={{
                            cursor: 'pointer',
                            color: '#007bff',
                            textDecoration: 'underline',
                            fontWeight: '500'
                          }}
                          title={`Click to edit ${formattedValue}`}
                        >
                          {formattedValue}
                        </span>
                      );
                    }

                    if (column.key === 'jobReqStatus') {
                      cellContent = (
                        <span className={`status-badge status-${value?.toLowerCase() || 'unknown'}`}>
                          {formattedValue}
                        </span>
                      );
                    }

                    if (column.key === 'salary') {
                      cellContent = value ? `₹${formatValue(value)}` : 'Not specified';
                    }

                    if (column.key === 'interviewDate' && value) {
                      const date = new Date(value);
                      cellContent = date.toLocaleDateString('en-IN', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                      });
                    }
                    if (column.key === 'totalSelectionCount') {
                      cellContent = value !== null && value !== undefined
                        ? value
                        : <span style={{ color: '#999', fontStyle: 'italic' }}>N/A</span>;
                    }
                    if (column.key === 'createdAt' && value) {
                      const date = new Date(value);

                      cellContent = date.toLocaleString('en-IN', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                      });
                    }
                    return (
                      <td
                        key={column.key}
                        className={`table-cell cell-${column.key}`}
                        title={column.key === 'jobReqId' ? undefined : formattedValue}
                      >
                        {cellContent}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;